const URL_PROTOCOL_PATTERN = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//;

/** Keep persisted value as-entered (minus whitespace) to avoid destructive rewrites. */
export function sanitizeWebsiteUrlForSave(value: string | null | undefined): string {
  return (value || '').trim();
}

/** Build a safe external href for anchor tags; defaults to https when protocol is omitted. */
export function getWebsiteLinkHref(value: string | null | undefined): string | null {
  const trimmed = sanitizeWebsiteUrlForSave(value);
  if (!trimmed) return null;
  const candidate = URL_PROTOCOL_PATTERN.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const parsed = new URL(candidate);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    return parsed.toString();
  } catch {
    return null;
  }
}

/** Prefer a compact domain/path label when possible. */
export function getWebsiteDisplayText(value: string | null | undefined): string {
  const trimmed = sanitizeWebsiteUrlForSave(value);
  if (!trimmed) return '';
  const href = getWebsiteLinkHref(trimmed);
  if (!href) return trimmed;
  try {
    const parsed = new URL(href);
    const path = parsed.pathname && parsed.pathname !== '/' ? parsed.pathname : '';
    return `${parsed.host}${path}`;
  } catch {
    return trimmed;
  }
}
